/**
 * Suchindex — ein vorbereitetes Verzeichnis für die Suche an der Oberfläche.
 *
 * Warum als Artefakt und nicht als Abfrage: Firestore kann keinen Volltext.
 * Wortlisten dort zu indizieren hieße, keine Teilwörter, keine Relevanz und
 * keine Tippfehler-Toleranz zu haben — und würde genau die Index-Aufblähung
 * erzeugen, die wir beim Datenmodell vermeiden. Der Index ist klein genug,
 * um ihn einmal zu laden (Größenordnung: gut hunderttausend Bytes gepackt),
 * und wird bei jedem Pipeline-Lauf neu gebaut.
 *
 * Bewusst NICHT enthalten: Sitzungen. Sie heißen fast alle „Sitzung der
 * Bezirksvertretung …" — danach sucht niemand, und sie verwässern die
 * Treffer. Man findet sie über Gremium und Datum.
 *
 * Zur Suche selbst: Kleinschreibung und Umlaut-Faltung sind hier ausdrücklich
 * erlaubt. Das ist kein Widerspruch zur Regel „keine Normalisierung" — die
 * gilt für IDENTITÄTEN (wir raten nie, dass zwei Schreibweisen dasselbe
 * Gebiet meinen). In einem Suchfeld behauptet niemand etwas über die Daten;
 * dort tippt ein Mensch „muelheim" und meint Mülheim.
 */
// =============================================================================
// Call-Shape (öffentlich, read-only)
// =============================================================================
export const SUCHINDEX_OBJECT = "suchindex";
/** Dateinamen des Artefakts — derselbe Vertrag für Pipeline und App. */
export const DRUCKSACHEN_LISTE_MANIFEST = "drucksachen-liste.json";
export const drucksachenListeDatei = (jahr) => `drucksachen-liste-${jahr}.json`;
export const SITZUNGEN_LISTE_MANIFEST = "sitzungen-liste.json";
export const sitzungenListeDatei = (jahr) => `sitzungen-liste-${jahr}.json`;
//# sourceMappingURL=suche-model.js.map